export const EIA_DEPOSIT_PERCENTAGE = 'eiaDepositPercentage';
export const PERCENTAGE_CREDIT_FOREGONE = 'percentageCreditForegone';
